import { Box, Flex, Image } from '@chakra-ui/react';
import lockIcon from '../assets/lockIcon.png';

interface NavButtonProps {
  selected: boolean;
  disabled: boolean;
  image: string;
  selectedImage: string;
  alt: string;
  onClick: () => void;
}

const NavButton = ({ selected, image, selectedImage, alt, disabled, onClick }: NavButtonProps) => {
  return (
    <Flex
      position="relative"
      direction="row"
      align="center"
      justify="center"
      width={10}
      height={10}
      borderRadius="full"
      onClick={onClick}
    >
      <Image
        src={selected ? selectedImage : image}
        alt={alt}
        width={10}
        height={10}
        objectFit="contain"
        cursor={disabled ? 'not-allowed' : 'pointer'}
        transition="opacity 0.2s"
        _hover={{ opacity: disabled ? 0.2 : 0.8 }}
        opacity={disabled ? 0.2 : 1}
        filter={disabled ? 'grayscale(100%)' : 'none'}
      />
      {disabled && (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image src={lockIcon} width="12px" height="15px" position="absolute" aria-label="Locked feature" />
        </Box>
      )}
    </Flex>
  );
};

export default NavButton;
